import React, { useState, useEffect } from 'react';
import map from '../../images/mapa.webp'
import sectorPoniente from '../../images/sectorPoniente.webp'
import sectorSur from '../../images/sectorSur.webp'
import sectorOriente from '../../images/sectorOriente.webp'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Map() {

    useEffect(() => {
        // Inicializa AOS solo cuando el componente se monta en el cliente
        AOS.init({
          duration: 500,
          easing: 'ease-in-out',
        });
      }, []);

    const [activeSector, setActiveSector] = useState(null);

    const handleMouseEnter = (sector) => {
        setActiveSector(sector);
    };

    const handleMouseLeave = () => {
        setActiveSector(null);
    };

  return (
    <div className="Content__map homeMap" id="map">
        <div className="container">
            <div className="Content__map--container" data-aos="fade-down" data-aos-delay="300">
                <div className="Content__map--left">
                    <div className="Content__map--title">
                        <h2>Nuestra <span>cobertura</span></h2>
                    </div>
                    <div className="Content__map--subtitle">
                        <span>Región Metropolitana</span>
                    </div>
                    <div className="Content__map--description">
                        <p>Nuestra cobertura en la región metropolitana incluye las principales comunas urbanas, asegurando un servicio integral y eficiente. Conectamos áreas clave para brindar soluciones accesibles y confiables a nuestros usuarios.</p>
                    </div>
                    <div className="Content__map--mobileButtons">
                        <div className="Content__map--button">
                            <button
                            onMouseEnter={() => handleMouseEnter("Poniente")}
                            onMouseLeave={handleMouseLeave}
                            >Sector Nor-Poniente</button>
                            <ul className={`defaultMap ${activeSector === "Poniente" ? 'activeList' : ''}`}>
                                <li>Quilicura, </li>
                                <li>Renca, </li>
                                <li>Cerro Navia, </li>
                                <li>Huechuraba, </li>
                                <li>Conchalí, </li>
                                <li>Independencia, </li>
                                <li>Recoleta, </li>
                                <li>Lo Prado, </li>
                                <li>Estación Central, </li>
                                <li>Cerrillos, </li>
                                <li>Maipú, </li>
                                <li>Pudahuel</li>
                                <li>Colina</li>
                                <li>Padre Hurtado</li>
                            </ul>  
                        </div>
                        <div className="Content__map--button">
                        <button
                            onMouseEnter={() => handleMouseEnter("Oriente")}
                            onMouseLeave={handleMouseLeave}
                            >Sector Oriente</button>
                            <ul className={`defaultMap ${activeSector === "Oriente" ? 'activeList' : ''}`}>
                                <li>Vitacura, </li>
                                <li>Los Condes, </li>
                                <li>Providencia, </li>
                                <li>La Reina, </li>
                                <li>Ñuñoa, </li>
                                <li>Macul, </li>
                                <li>Santiago, </li>
                                <li>San Miguel, </li>
                                <li>San Joaquin, </li>
                                <li>Macul, </li>
                                <li>Peñalolén, </li>
                                <li>Lo Barnechea</li>
                            </ul>  
                        </div>
                        <div className="Content__map--button">
                            <button
                            onMouseEnter={() => handleMouseEnter("Sur")}
                            onMouseLeave={handleMouseLeave}
                            >Sector Sur</button>
                            <ul className={`defaultMap ${activeSector === "Sur" ? 'activeList' : ''}`}>
                                <li>Pedro Aguirre Cerda, </li>
                                <li>Lo Espejo, </li>
                                <li>La Cisterna, </li>
                                <li>San Ramón, </li>
                                <li>La Granja, </li>
                                <li>La Florida, </li>
                                <li>El Bosque, </li>
                                <li>La Pintana, </li>
                                <li>Puente Alto, </li>
                                <li>San Bernardo</li>
                            </ul>  
                        </div>
                    </div>
                    <div className="Content__map--button desktopButton">
                        <button
                        onMouseEnter={() => handleMouseEnter("Poniente")}
                        onMouseLeave={handleMouseLeave}
                        >Sector Nor-Poniente</button>
                        <ul className={`defaultMap ${activeSector === "Poniente" ? 'activeList' : ''}`}>
                            <li>Quilicura</li>
                            <li>Renca</li>
                            <li>Cerro Navia</li>
                            <li>Huechuraba</li>
                            <li>Conchalí</li>
                            <li>Independencia</li>
                            <li>Recoleta</li>
                            <li>Lo Prado</li>
                            <li>Estación Central</li>
                            <li>Cerrillos</li>
                            <li>Maipú</li>
                            <li>Pudahuel</li>
                            <li>Colina</li>
                            <li>Padre Hurtado</li>
                        </ul>  
                    </div>
                </div>
                <div className="Content__map--map">
                    <img src={map} alt="mapa-sin-resaltado" className={`activeMap`} width="717" height="699" />
                    <img src={sectorPoniente} alt="mapa-sector-poniente" className={`sectorPoniente ${activeSector === "Poniente" ? 'activeMap' : ''}`} width="717" height="699" />
                    <img src={sectorSur} alt="mapa-sector-sur" className={`sectorSur ${activeSector === "Sur" ? 'activeMap' : ''}`} width="717" height="699" />
                    <img src={sectorOriente} alt="mapa-sector-oriente" className={`sectorOriente ${activeSector === "Oriente" ? 'activeMap' : ''}`} width="717" height="699" />
                </div>
                <div className="Content__map--right">
                    <div className="Content__map--right-button desktopButton">
                        <button
                        onMouseEnter={() => handleMouseEnter("Oriente")}
                        onMouseLeave={handleMouseLeave}
                        >Sector Oriente</button>
                        <ul className={`defaultMap ${activeSector === "Oriente" ? 'activeList' : ''}`}>
                            <li>Vitacura</li>
                            <li>Los Condes</li>
                            <li>Providencia</li>
                            <li>La Reina</li>
                            <li>Ñuñoa</li>
                            <li>Macul</li>
                            <li>Santiago</li>
                            <li>San Miguel</li>
                            <li>San Joaquin</li>
                            <li>Macul</li>
                            <li>Peñalolén</li>
                            <li>Lo Barnechea</li>
                        </ul>  
                    </div>
                    <div className="Content__map--right-button desktopButton">
                        <button
                        onMouseEnter={() => handleMouseEnter("Sur")}
                        onMouseLeave={handleMouseLeave}
                        >Sector Sur</button>
                        <ul className={`defaultMap ${activeSector === "Sur" ? 'activeList' : ''}`}>
                            <li>Pedro Aguirre Cerda</li>
                            <li>Lo Espejo</li>
                            <li>La Cisterna</li>
                            <li>San Ramón</li>
                            <li>La Granja</li>
                            <li>La Florida</li>
                            <li>El Bosque</li>
                            <li>La Pintana</li>
                            <li>Puente Alto</li>
                            <li>San Bernardo</li>
                        </ul>  
                    </div>
                </div>
            </div>
            <div className="Content__map--disclaimer">
                <div className="disclaimerIcon">
                    <FontAwesomeIcon icon={faExclamation} />
                </div>
                <p>Importante! No contamos con <strong>zonas rojas</strong></p>
            </div>
        </div>
    </div>
  )
}

export { Map }